// Simple local reviews store with seed data per product.
// Combines seeded reviews with user-submitted reviews stored in localStorage.

const STORAGE_KEY = 'pb_reviews';

const SEED_REVIEWS = {
  // Example seeds: provide a few believable, short reviews
  // Product IDs from FakeStore API are numbers in string form in our app for local items too
  '1': [
    { id: 'r1', name: 'Ayesha K.', rating: 5, comment: 'Excellent quality and fast delivery. Highly recommended!', date: '2025-08-12T10:30:00Z', verified: true },
    { id: 'r2', name: 'Ali R.', rating: 4, comment: 'Good product for the price. Packaging could be better.', date: '2025-09-03T14:05:00Z', verified: true }
  ],
  '2': [
    { id: 'r3', name: 'Maria S.', rating: 5, comment: 'Loved it! Exactly as described.', date: '2025-07-22T09:12:00Z', verified: true }
  ]
};

function safeParse(json, fallback) {
  try {
    const parsed = JSON.parse(json);
    return parsed === null ? fallback : parsed;
  } catch {
    return fallback;
  }
}

export function getReviews(productId) {
  const id = String(productId);
  const ls = safeParse(localStorage.getItem(STORAGE_KEY), {});
  const userList = Array.isArray(ls[id]) ? ls[id] : [];
  const seeds = Array.isArray(SEED_REVIEWS[id]) ? SEED_REVIEWS[id] : [];
  const list = [...seeds, ...userList];
  // latest first
  return list.sort((a,b)=> new Date(b.date) - new Date(a.date));
}

export function addReview(productId, review) {
  const id = String(productId);
  const now = new Date().toISOString();
  const entry = {
    id: `${id}-${Date.now().toString(36)}`,
    name: review.name?.slice(0,60) || 'Anonymous',
    rating: Math.max(1, Math.min(5, Number(review.rating) || 5)),
    comment: review.comment?.slice(0, 1000) || '',
    date: now,
    verified: false
  };
  const current = safeParse(localStorage.getItem(STORAGE_KEY), {});
  const list = Array.isArray(current[id]) ? current[id] : [];
  list.push(entry);
  current[id] = list;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(current));
  return entry;
}
